module.exports = __webpack_public_path__ + "media/images/harvest_12_2020-51fa3eefa4627abf3ee1b74845ff7ec9.png";